import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "slices/thunk";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

const Logout = () => {
  document.title = "Log Out | Quotations Management";

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const selectLogin = createSelector(
    (state: any) => state.Login,
    (login) => ({
      isUserLogout: login.isUserLogout,
    })
  );

  const { isUserLogout } = useSelector(selectLogin);

  useEffect(() => {
    dispatch(logoutUser()).then(() => {
      toast.success("User logged out successfully");
      navigate("/login");
    });
  }, [dispatch, navigate]);

  return (
    <React.Fragment>
       <ToastContainer position="top-center" autoClose={3000} /> 
    </React.Fragment>
  );
};

export default Logout;
